import { Col, Divider, Form, Input, Radio, Row } from 'antd'
import { FormInstance, RadioChangeEvent } from 'antd/lib'
import { useState } from 'react'

import { requiredRules } from 'src/app-constants'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

import { useStyles } from '../styles'

type Props = {
  form: FormInstance
  isPrimary: boolean
}

export const ConsultationFormNeurologicalSection = ({
  form,
  isPrimary
}: Props) => {
  const { t } = useLocales()
  const { styles } = useStyles()

  const [isNeurologicalSelected, setIsNeurologicalSelected] = useState(false)
  const [isVisualSelected, setIsVisualSelected] = useState(false)
  const [isAuditiveSelected, setIsAuditiveSelected] = useState(false)

  const onNeurologicalChange = (e: RadioChangeEvent) => {
    const value = e.target.value

    setIsNeurologicalSelected(value)

    form.setFieldsValue({
      form: {
        physicalExaminationSection: {
          neurologicalStatusAssessment: {
            meningealSigns: {
              isPositive: {
                isSelected: value,
                value: undefined
              }
            }
          }
        }
      }
    })
  }

  const onVisualChange = (e: RadioChangeEvent) => {
    const value = e.target.value

    setIsVisualSelected(value)

    form.setFieldsValue({
      form: {
        physicalExaminationSection: {
          visualFunctionsAssessment: {
            isAffected: {
              isSelected: value,
              value: undefined
            }
          }
        }
      }
    })
  }

  const onAuditiveChange = (e: RadioChangeEvent) => {
    const value = e.target.value

    setIsAuditiveSelected(value)

    form.setFieldsValue({
      form: {
        physicalExaminationSection: {
          auditoryFunctionsAssessment: {
            isAffected: {
              isSelected: value,
              value: undefined
            }
          }
        }
      }
    })
  }

  return (
    <>
      <Col span={24}>
        <Text>
          {isPrimary ? '27.' : '22.'}{' '}
          {t('consultation_form.neuorological.title')}
        </Text>

        <Row gutter={[16, 16]} className="mt-16 ml-16">
          <Col span={12}>
            <Form.Item
              name={[
                'form',
                'physicalExaminationSection',
                'neurologicalStatusAssessment',
                'meningealSigns',
                'isPositive',
                'isSelected'
              ]}
              label={`${isPrimary ? 27 : 22}.1 ${t('consultation_form.neuorological.meningeal_signs')}`}
              rules={requiredRules}
            >
              <Radio.Group onChange={onNeurologicalChange}>
                <Radio value={true}>
                  {t('consultation_form.neuorological.isPositive')}
                </Radio>

                <Radio value={false}>
                  {t('consultation_form.neuorological.isNegative')}
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Col>

          {isNeurologicalSelected && (
            <Col span={12}>
              <Form.Item
                name={[
                  'form',
                  'physicalExaminationSection',
                  'neurologicalStatusAssessment',
                  'meningealSigns',
                  'isPositive',
                  'value'
                ]}
                rules={requiredRules}
              >
                <Input.TextArea
                  placeholder={t('consultation_form.to_specify')}
                />
              </Form.Item>
            </Col>
          )}
        </Row>
      </Col>

      <Divider className={styles.divider} />

      <Col span={24}>
        <Form.Item
          name={[
            'form',
            'physicalExaminationSection',
            'visualFunctionsAssessment',
            'isAffected',
            'isSelected'
          ]}
          label={`${isPrimary ? 28 : 23}. ${t('consultation_form.visual_functions.title')}`}
          rules={requiredRules}
        >
          <Radio.Group onChange={onVisualChange}>
            <Radio value={true}>{t('consultation_form.isAffected')}</Radio>

            <Radio value={false}>{t('consultation_form.isNotAffected')}</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      {isVisualSelected && (
        <Col span={24}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'visualFunctionsAssessment',
              'isAffected',
              'value'
            ]}
            rules={requiredRules}
          >
            <Input.TextArea placeholder={t('consultation_form.to_specify')} />
          </Form.Item>
        </Col>
      )}

      <Divider className={styles.divider} />

      <Col span={24}>
        <Form.Item
          name={[
            'form',
            'physicalExaminationSection',
            'auditoryFunctionsAssessment',
            'isAffected',
            'isSelected'
          ]}
          label={`${isPrimary ? 29 : 24}. ${t('consultation_form.auditive_functions.title')}`}
          rules={requiredRules}
        >
          <Radio.Group onChange={onAuditiveChange}>
            <Radio value={true}>{t('consultation_form.isAffected')}</Radio>

            <Radio value={false}>{t('consultation_form.isNotAffected')}</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      {isAuditiveSelected && (
        <Col span={24}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'auditoryFunctionsAssessment',
              'isAffected',
              'value'
            ]}
            rules={requiredRules}
          >
            <Input.TextArea placeholder={t('consultation_form.to_specify')} />
          </Form.Item>
        </Col>
      )}
    </>
  )
}
